import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Eye = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/eye">
        <g id="eye">
          <path
            id="Vector"
            d="M7.99995 10.8866C6.40661 10.8866 5.11328 9.59328 5.11328 7.99995C5.11328 6.40661 6.40661 5.11328 7.99995 5.11328C9.59328 5.11328 10.8866 6.40661 10.8866 7.99995C10.8866 9.59328 9.59328 10.8866 7.99995 10.8866ZM7.99995 6.11328C6.95995 6.11328 6.11328 6.95995 6.11328 7.99995C6.11328 9.03995 6.95995 9.88661 7.99995 9.88661C9.03995 9.88661 9.88661 9.03995 9.88661 7.99995C9.88661 6.95995 9.03995 6.11328 7.99995 6.11328Z"
          />
          <path
            id="Vector_2"
            d="M7.99875 14.0134C5.49208 14.0134 3.12542 12.5467 1.49875 10C0.792083 8.90003 0.792083 7.10669 1.49875 6.00003C3.13208 3.45336 5.49875 1.98669 7.99875 1.98669C10.4988 1.98669 12.8654 3.45336 14.4921 6.00003C15.1988 7.10003 15.1988 8.89336 14.4921 10C12.8654 12.5467 10.4988 14.0134 7.99875 14.0134ZM7.99875 2.98669C5.84542 2.98669 3.78542 4.28003 2.34542 6.54003C1.84542 7.32003 1.84542 8.68003 2.34542 9.46003C3.78542 11.72 5.84542 13.0134 7.99875 13.0134C10.1521 13.0134 12.2121 11.72 13.6521 9.46003C14.1521 8.68003 14.1521 7.32003 13.6521 6.54003C12.2121 4.28003 10.1521 2.98669 7.99875 2.98669Z"
          />
        </g>
      </g>
    </svg>
  );
};

Eye.displayName = 'Eye';
